import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from 'src/app/core/config/application-config.service';
import { CreateTicketRequest, PagedTickets, SupportTicket, TicketCategory, TicketListState, TicketRaiseContext, TicketSummary } from '../models/ticket.model';

@Injectable({ providedIn: 'root' })
export class TicketService {
  private readonly resourceUrl: string;
  constructor(private http: HttpClient, config: ApplicationConfigService) {
    this.resourceUrl = config.getJpaMicroServiceEndpointFor('api/support-tickets');
  }
  getTickets(state: TicketListState, page: number, size: number, search = '', from?: number, to?: number): Observable<PagedTickets> {
    let params = new HttpParams().set('state', state).set('page', page).set('size', size);
    if (search.trim()) params = params.set('search', search.trim());
    if (from !== undefined) params = params.set('from', from);
    if (to !== undefined) params = params.set('to', to);
    return this.http.get<PagedTickets>(this.resourceUrl, { params });
  }
  getSummary(from?: number, to?: number): Observable<TicketSummary> {
    let params = new HttpParams();
    if (from !== undefined) params = params.set('from', from);
    if (to !== undefined) params = params.set('to', to);
    return this.http.get<TicketSummary>(`${this.resourceUrl}/summary`, { params });
  }
  getTicket(id: number): Observable<SupportTicket> { return this.http.get<SupportTicket>(`${this.resourceUrl}/${id}`); }
  getRaiseContext(): Observable<TicketRaiseContext> { return this.http.get<TicketRaiseContext>(`${this.resourceUrl}/raise-context`); }
  getCategories(): Observable<TicketCategory[]> { return this.http.get<TicketCategory[]>(`${this.resourceUrl}/categories`); }
  create(request: CreateTicketRequest): Observable<SupportTicket> { return this.http.post<SupportTicket>(this.resourceUrl, request); }
  addMessage(id: number, message: string): Observable<SupportTicket> { return this.http.post<SupportTicket>(`${this.resourceUrl}/${id}/messages`, { message }); }
  uploadAttachment(id: number, file: File): Observable<SupportTicket> {
    const data = new FormData(); data.append('file', file, file.name);
    return this.http.post<SupportTicket>(`${this.resourceUrl}/${id}/attachments`, data);
  }
  retrySync(id: number): Observable<SupportTicket> { return this.http.post<SupportTicket>(`${this.resourceUrl}/${id}/retry-sync`, {}); }
}
